module.exports = __webpack_public_path__ + "static/hand-db63f1a12facac228465fc79df4ef4c7.png";